import React from "react";
import WhatIDoSection from "../components/WhatIDoSection";
import SkillsSection from "../components/SkillSection";

const AboutSection = () => {
  return (
    <section className="space-y-6 text-blacktext dark:text-white">
      <header>
        <h2 className="text-xl md:text-2xl font-bold text-mint-700 dark:text-riptide-300">
          About Me
        </h2>
        <div className="w-16 h-1 bg-mint-400 dark:bg-riptide-400 rounded-full mt-2"></div>
      </header>

      <div className="space-y-4 text-base leading-relaxed">
        <p>
          Hey there! I'm{" "}
          <span className="font-semibold text-mint-600 dark:text-riptide-300">
            Syed Shahid Ali 
          </span>{" "}
          — an innovative Full Stack Developer  with over 3 years of experience in building scalable web and mobile applications. I'm proficient in Node.js, React.js, Next.js, and MongoDB. My focus is on crafting robust, high-performance digital solutions that are both functional and elegant.
        </p>
        <p>
          I have a passion for problem-solving, writing clean code, and continuous learning. I specialize in API development, performance optimization, and cloud integrations. When I'm not coding, you'll find me exploring new technologies or contributing to projects that push the boundaries of what's possible on the web. Let's connect and build something awesome together!
        </p>
      </div>
      <WhatIDoSection />
      <SkillsSection />
    </section>
  );
};
export default AboutSection;
